export default __webpack_public_path__ + "ed590535e7a47edfb011c242f7218cc8.ico";